export const ProjectInvatationLabelToken = Symbol('ProjectInvatationLabelToken');